import { Typography } from 'src/components/common/Typography'
import { Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import React from 'react'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import usePageNav from 'src/hooks/usePageNav.hook'
import RenderIf from 'src/components/common/RenderIf'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'

const GiftHeader = ({
  isLogoTitle,
  title,
  isBackBtn,
  isFull,
}: {
  isLogoTitle?: boolean
  title?: string
  isBackBtn?: boolean
  isFull?: boolean
}) => {
  const { navigatePrev } = usePageNav()
  const backIcon = `${process.env.PUBLIC_URL}/images/arrow_back_icon.svg`
  const textLogo = `${process.env.PUBLIC_URL}/images/text_logo.svg`

  return (
    <S.HeaderContainer $option="flex_row" $isFull={isFull}>
      <RenderIf when={isBackBtn}>
        <S.BackBtn onClick={navigatePrev}>
          <img src={backIcon} alt={'뒤로가기'} />
        </S.BackBtn>
      </RenderIf>
      <RenderIf when={isLogoTitle}>
        <S.TextLogoImage src={textLogo} alt="logo" />
      </RenderIf>
      <RenderIf when={!!title}>
        <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-100)">
          {title}
        </Typography>
      </RenderIf>
    </S.HeaderContainer>
  )
}

export default GiftHeader

const S = {
  HeaderContainer: styled(Container)<{ $isFull?: boolean }>`
    ${({ $isFull }) => !$isFull && layoutMaxSize};
    position: fixed;
    top: 0;
    justify-content: center;
    align-items: center;
    height: 50px;
    background-color: var(--white);
    z-index: ${ZIndex.TopMenu};
  `,
  BackBtn: styled.button`
    position: absolute;
    top: 6px;
    left: 10px;
    width: 38px;
    height: 38px;
  `,
  TextLogoImage: styled.img`
    width: 146px;
  `,
}
